import React from 'react';
import { SectionLabel } from './SectionLabel';
export function Ashley() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-9" data-mp="7zfngi7f97b5">
      <SectionLabel number="03" title="The Principal" data-id="element-10" data-mp="lyotip1wyl1e" />

      <div className="max-w-3xl" data-id="element-11" data-mp="ly5m429w3f1m">
        <h2 className="text-5xl md:text-6xl mb-4" data-id="element-12" data-mp="gzu9xkw4gsg8">Ashley Garcia</h2>
        <div className="font-mono text-xs uppercase tracking-widest text-brass mb-12" data-id="element-13" data-mp="h0n8hykxgbna">
          Principal
        </div>

        <div className="font-sans text-lg font-light text-ink/80 leading-relaxed space-y-6" data-id="element-14" data-mp="3pdb4lbhkr9ey">
          <p data-id="element-15" data-mp="3kepywwjjzxj4">
            Board-certified health and wellness coach. IFBB professional
            athlete. Sixteen years designing and running health programs for
            executives, founders, and high performers.
          </p>
          <p data-id="element-16" data-mp="36omhcivmcs00">
            The standard I hold myself to is the only standard the house knows.
          </p>
        </div>
      </div>
    </section>;
}